import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight, CalendarCheck } from "lucide-react";
import { activeCourses, upcomingDates } from "@/data/site";
import { useBooking } from "@/components/site/BookingContext";

const upcoming = activeCourses()
  .flatMap((c) =>
    upcomingDates(c.id).map((d) => ({
      courseId: c.id,
      course: c.title,
      ...d,
    }))
  )
  .sort((a, b) => new Date(a.iso) - new Date(b.iso))
  .slice(0, 6);

export const UpcomingDates = () => {
  const { openBooking } = useBooking();
  return (
    <section id="date" data-testid="dates-section" className="py-24 md:py-32 bg-brand-black text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-4">
              Calendario
            </div>
            <h2 className="font-heading font-bold text-4xl md:text-6xl tracking-tighter leading-none">
              Prossime   date
            </h2>
          </div>
          <p className="max-w-sm text-sm text-white/60 leading-relaxed">
            Le sessioni in programma. Posti limitati: prenota in anticipo per
            assicurarti il tuo posto.
          </p>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {upcoming.map((d, i) => (
            <motion.div
              key={i}
              data-testid={`date-row-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="group grid grid-cols-1 md:grid-cols-12 items-center gap-3 md:gap-6 py-6"
            >
              <div className="md:col-span-3 flex items-center gap-3">
                <CalendarDays size={18} className="text-brand-red shrink-0" />
                <span className="font-heading font-bold text-xl">{d.date}</span>
              </div>
              <div className="md:col-span-3 font-semibold">{d.course}</div>
              <div className="md:col-span-2 text-sm text-white/60">{d.time}</div>
              <div className="md:col-span-2 text-xs uppercase tracking-widest text-brand-red">
                {d.seats}
              </div>
              <div className="md:col-span-2 flex items-center gap-4 md:justify-end">
                <button
                  onClick={() => openBooking(d.course, d.date)}
                  data-testid={`date-book-${i}`}
                  className="inline-flex items-center gap-1.5 bg-brand-red text-white text-xs font-bold uppercase tracking-widest px-4 py-2.5 hover:bg-white hover:text-brand-black transition-colors"
                >
                  <CalendarCheck size={14} /> Prenota
                </button>
                <Link
                  to={`/corsi/${d.courseId}`}
                  data-testid={`date-link-${i}`}
                  className="hidden lg:inline-flex items-center gap-1 text-sm font-bold uppercase tracking-widest text-white/60 hover:text-brand-red transition-colors"
                >
                  Info <ArrowRight size={15} />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-xs text-white/40">
          * Calendario ufficiale del centro — le date si aggiornano automaticamente.
        </p>
      </div>
    </section>
  );
};
